import { TaskProgress } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    taskProgress: {}
  },
  actions: {
    async fetchTasProgess({ state, commit }, id) {
      let taskProgress = await TaskProgress.fetchOne(id)
      commit('changeState', { taskProgress })
    },
    async uploadAvatarStudents({ state, commit }, formData) {
      console.log(formData)
      let taskProgress = await TaskProgress.uploadAvatar(formData)
      commit('changeState', { taskProgress })
    }
  },
  getters: {
    taskProgress(state) {
      return state.taskProgress
    }
  }
}
